<template>
    <div v-if="mostrar" class="modal-mask" @click="$emit('fechar')">
        <div class="jm" style="height: min-content; width: 50rem; padding: 2rem;" @click.stop>
            <div style="display: flex; justify-content: center">
                <h2>{{ programaNome }}</h2>
            </div>
            <br>
            <div style="width: 100%; display: flex; justify-content: center;">
                <div style="width: 50%;">
                    <label>Data de término do programa:</label>
                    <input :class="{ shake: showShake }" v-model="dataTermino" id="dataTermino"
                        class="form-control" type="date">
                </div>
                <div style="align-content: end; margin-left: 1rem;">
                    <button class="button" @click="onFinalizar">Finalizar Programa</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ModalFinalizarPrograma",
    props: {
        mostrar: { type: Boolean, default: false },
        programaNome: { type: String, default: "" },
    },
    emits: ["fechar", "finalizar"],
    data() {
        return {
            dataTermino: null,
            showShake: false,
        };
    },
    watch: {
        mostrar(visivel) {
            if (visivel) this.dataTermino = null;
        },
    },
    methods: {
        onFinalizar() {
            if (this.dataTermino === null) {
                const el = document.getElementById("dataTermino");
                if (el) el.style.border = "1px solid red";
                this.showShake = true;
                setTimeout(() => { this.showShake = false; }, 1500);
                return;
            }
            this.$emit("finalizar", this.dataTermino);
        },
    },
};
</script>
